import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-profile-image-modal',
  standalone: true,
  imports: [CommonModule, IonicModule],
  template: `
    <ion-content class="ion-no-padding">
      <div class="profile-image-container" (click)="dismissModal()">
        <img [src]="imageUrl" alt="Profile Image" class="profile-image-large">
      </div>
    </ion-content>
  `,
  styles: [`
    .profile-image-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0);
    }
    
    .profile-image-large {
      max-width: 90vw;
      max-height: 80vh;
      object-fit: contain;
      border-radius: 8px;
      animation: zoomIn 0.3s ease-out forwards;
    }
    
    @keyframes zoomIn {
      from {
        opacity: 0;
        transform: scale(0.8);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  `]
})
export class ProfileImageModalComponent {
  @Input() imageUrl: string;

  constructor(private modalCtrl: ModalController) {}

  dismissModal() {
    this.modalCtrl.dismiss();
  }
} 